import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';
import {
  CompanyProfileDto,
  MdaContactDto,
  UpdateAddressDto,
  UpdateCompanyProfileDto,
  UpdateConsentDto,
  UpdateSalespersonsDto,
} from 'components/intermediaryApplications/intermediaryApplications.dto';

export class IntermediaryApplicationsApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/intermediaryApplications');
  }

  public async getCompanyProfile() {
    return this.instance.get('/profile').then((response: AxiosResponse<CompanyProfileDto>) => response.data);
  }

  public async getMdaContacts() {
    return this.instance.get('/mda-contacts').then((response: AxiosResponse<MdaContactDto[]>) => response.data);
  }

  public async updateCompanyProfile(body: UpdateCompanyProfileDto) {
    return this.instance.put('/profile', body).then((response: AxiosResponse<CompanyProfileDto>) => response.data);
  }

  public async updateAddress(body: UpdateAddressDto) {
    return this.instance.put('/address', body).then((response: AxiosResponse<CompanyProfileDto>) => response.data);
  }

  public async updateSalespersons(body: UpdateSalespersonsDto) {
    return this.instance.put('/salespersons', body).then((response: AxiosResponse<CompanyProfileDto>) => response.data);
  }

  public async signMasterDealerAgreement() {
    return this.instance.put('/mda').then((response: AxiosResponse<CompanyProfileDto>) => response.data);
  }

  public async getMasterDealerAgreement() {
    return this.instance.get('/mda').then((response: AxiosResponse<any>) => response.data);
  }

  public async declineMasterDealerAgreement() {
    return this.instance.post('/decline-mda').then((response: AxiosResponse<any>) => response.data);
  }

  public async updateConsent(body: UpdateConsentDto) {
    const params = new URLSearchParams();

    return this.instance
      .put('/consent', body, { params: params })
      .then((response: AxiosResponse<CompanyProfileDto>) => response.data);
  }
}
